module.exports = __webpack_public_path__ + "static/img/pytho.5e7fc458.png";